// extracted by mini-css-extract-plugin
export default {"main":"styles_main__lsRPE","container":"styles_container__Yluzs","form":"styles_form__uonJS","w100":"styles_w100__Fvcel","w50":"styles_w50__v3-lo","send":"styles_send__BbfvO"};